export default __webpack_public_path__ + "static/media/6.8c277f91.jpeg";